<template>
  <div class="Gauge3Charts">
    <div class="echarts" :id="Configuration.id"></div>
  </div>
</template>

<script>
import * as Echarts from 'echarts';
import { request } from '../../../../common/request';
export default {
  name: 'Gauge3Charts',
  components: {},
  props: {
    // 当前 页面 所有 场景 数据
    ProjectInfo: Object,
    //选中 拖出 图表 数据
    Configuration: Object,
  },
  data() {
    return {
      echartsOptions: {},
      apiIntervalTaskID: null,
      staticIntervalTaskID: null,
    };
  },
  watch: {
    Configuration: {
      deep: true,
      handler: function () {
        if (this.Configuration.isScaling) {
          this.throttle_resizeEcharts();
        } else if (this.Configuration.isMoving) {
          this.debounce_resizeEcharts();
        } else {
          this.debounce_subscribeConfigurationChange();
        }
      },
    },
  },
  created() {
    clearInterval(this.apiIntervalTaskID);
    clearInterval(this.staticIntervalTaskID);
    this.registerDebounceAndThrottle();
  },
  mounted() {
    this.$nextTick(() => {
      this.startApiIntervalTask();
      this.startStaticIntervalTask();
    });
    this.getApiDataResByFilterAndResponseQuery();
  },
  beforeUnmount() {
    clearInterval(this.apiIntervalTaskID);
    clearInterval(this.staticIntervalTaskID);
    this.destroyEcharts();
    this.unRegisterDebounceAndThrottle();
  },
  computed: {},
  methods: {
    registerDebounceAndThrottle() {
      this.debounce_resizeEcharts = this.$_.debounce(this.resizeEcharts, 100);
      this.debounce_subscribeConfigurationChange = this.$_.debounce(this.subscribeConfigurationChange, 500);
      this.throttle_resizeEcharts = this.$_.throttle(this.resizeEcharts, 20);
    },
    unRegisterDebounceAndThrottle() {
      this.debounce_resizeEcharts.cancel();
      this.debounce_subscribeConfigurationChange.cancel();
      this.throttle_resizeEcharts.cancel();
    },
    // 订阅Configuration变化将会执行的函数
    subscribeConfigurationChange() {
      clearInterval(this.apiIntervalTaskID);
      clearInterval(this.staticIntervalTaskID);
      this.startApiIntervalTask();
      this.startStaticIntervalTask();
    },
    setEchartsOptions(ParamData = null) {
      let grid = {};
      let chartColor = [];
      let source = [];
      let seriesList = [];
      let fontStyle = {
        titleColor: '#ccc',
        titleSize: 16,
        xAxisColor: '#c3dbff',
        xAxisSize: 12,
        yAxisColor: '#c3dbff',
        yAxisSize: 12,
      };

      if (this.Configuration.propertyData.chartsColor.value.chartColor) {
        chartColor = this.Configuration.propertyData.chartsColor.value.chartColor;
      }
      if (this.Configuration.propertyData.chartsGrid.value) {
        grid = this.Configuration.propertyData.chartsGrid.value;
      }
      if (ParamData && ParamData.source && ParamData.seriesList) {
        source = ParamData.source;
        seriesList = ParamData.seriesList;
      }
      if (this.Configuration.propertyData.fontStyle.value) {
        fontStyle = this.Configuration.propertyData.fontStyle.value;
      }

      let xData = [];
      let yData = [];
      let xyData = [];
      let minData = [];
      let maxData = [];
      let unit = '';
      let unxam = '';
      let uninm = '';

      function DealData() {
        seriesList.forEach((s, i, m) => {
          source.forEach((item, index) => {
            if (s === item.s || i === item.i || m === item.m) {
              unit = item.s;
              unxam = item.m;
              uninm = item.i;
              if (index >= 5) return;
              xData.push(item.x);
              yData.push(item.y);
              minData.push(item.min);
              maxData.push(item.max);
              xyData.push({
                name: item.x,
                value: parseInt(item.y),
                min: parseInt(item.min),
                max: parseInt(item.max),
              });
            }
          });
        });
      }
      DealData();

      console.log(unit, 'uuuuuuu');
      console.log(unxam, 'uuuuuuu');
      console.log(uninm, 'uuuuuuu');

      // 自定义图表颜色设置
      const colors = [
        [0, 255, 121, 25],
        [0.1, 252, 156, 11],
        [0.16, 255, 201, 0],
        [0.4, 226, 232, 4],
        [0.54, 142, 197, 120],
        [0.67, 15, 65, 121],
        [0.78, 0, 109, 254],
        [0.9, 0, 150, 168],
        [1, 1, 183, 125],
      ];

      // 将如: 0.04-0.16之间的渐变值补全
      const gradientColors = [];
      colors.forEach((color, i) => {
        if (i === colors.length - 1) return;
        let maxDiffValue = 0;
        const diffs = color.map((s, j) => {
          const diff = s - colors[i + 1][j];
          const positiveDiff = Math.abs(diff);
          if (Math.abs(maxDiffValue) < positiveDiff) {
            maxDiffValue = positiveDiff;
          }
          return diff;
        });
        gradientColors.push([color[0], `rgb(${color.slice(1).join(',')})`]);
        let start = color[0];
        const end = colors[i + 1][0];
        const step = (end - start) / maxDiffValue;
        for (let k = 0; k < maxDiffValue - 1; k++) {
          let rgb = 'rgb($0,$1,$2)';
          for (let o = 1; o < color.length; o++) {
            let c = color[o];
            c = c - diffs[o] / maxDiffValue;
            color[o] = c;
            rgb = rgb.replace(`$${o - 1}`, c);
          }
          start = start + step;
          gradientColors.push([start, rgb]);
        }
      });
      const lastColor = colors[colors.length - 1];
      gradientColors.push([lastColor[0], `rgb(${lastColor.slice(1).join(',')})`]);

      const dataValue = yData;
      const axisLabelData = xData;
      const axisMin = minData;
      const axisMax = maxData;
      // 内层刻度和指针
      const baseInner = {
        type: 'gauge',
        min: axisMin,
        max: axisMax,
        progress: {
          show: true,
          width: 9,
        },
        axisLine: {
          lineStyle: {
            width: 8,
            color: [[1, chartColor[0]]],
          },
        },
        splitLine: {
          length: 6,
          lineStyle: {
            width: 2,
            color: 'auto',
          },
        },
        axisTick: {
          show: false,
        },
        axisLabel: {
          color: 'auto',
          distance: 12,
          fontSize: 10,
        },
        anchor: {
          // 指针 中心圆 颜色
          show: true,
          showAbove: true,
          size: 8,
          itemStyle: {
            borderWidth: 14,
            color: 'auto',
          },
        },
        itemStyle: {
          // 动态进度条颜色
          color: '#4992ff',
        },
        pointer: {
          // 指针颜色
          width: 4, // 宽
          length: '50%', // 长
          itemStyle: {
            color: '#4992ff', // 颜色
          },
        },
      };
      let Options = [];
      var sCenter;
      var that = this;
      dataValue.forEach(function (item, index) {
        sCenter = [index * 10 + 50 + '%', '50%'];
        Options.push({
          ...baseInner,
          center: sCenter,
          detail: {
            valueAnimation: true,
            formatter: '{value}',
            offsetCenter: ['0', '50%'],
            fontSize: that.$h_Ratio(fontStyle.yAxisSize, that.$store),
            color: 'auto',
          },
          title: {
            offsetCenter: ['0', '0'],
            fontWeight: 800,
            fontSize: that.$h_Ratio(fontStyle.xAxisSize, that.$store),
            color: fontStyle.xAxisColor,
          },
          data: [
            {
              value: item,
              name: axisLabelData[index],
            },
          ],
        });
      });

      this.echartsOptions = {
        backgroundColor: this.Configuration.propertyData.chartsColor.value.chartBackgroundColor,
        series: Options,
      };
    },
    // 开启静态任务 数据是静态的
    startStaticIntervalTask() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      let chartsAnimation = this.Configuration?.propertyData?.chartsAnimation?.value;
      if (ChartsData?.currenEntry === 'staticData' && chartsAnimation?.isUseStaticRefresh) {
        // console.log('使用静态任务');
        let func = () => {
          this.setEchartsOptions(ChartsData.staticData);
          this.$nextTick(() => {
            this.createEcharts();
          });
        };
        clearInterval(this.staticIntervalTaskID);
        func();

        this.staticIntervalTaskID = setInterval(() => {
          console.log('任务执行staticData');
          console.log(chartsAnimation);
          func();
        }, chartsAnimation?.staticRefreshIntervalTime * 1000);
      } else if (ChartsData?.currenEntry === 'staticData') {
        console.log('无静态任务 执行staticData');
        this.setEchartsOptions(ChartsData.staticData);
        this.$nextTick(() => {
          this.createEcharts();
        });
      }
    },
    // 开启api动态任务 数据是动态的
    async startApiIntervalTask() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      // 判断是否使用apiData，使用动态interval请求
      if (ChartsData?.currenEntry === 'apiData' && ChartsData?.apiData?.isUseInterval) {
        // 开启interval任务 间隔请求
        let func = async () => {
          let res = await this.getApiDataResByFilterAndResponseQuery();
          this.setEchartsOptions(res);
          this.$nextTick(() => {
            this.createEcharts();
          });
        };
        func();
        this.apiIntervalTaskID = setInterval(async () => {
          // console.log('开启interval任务 间隔请求');
          func();
        }, ChartsData?.apiData?.apiInterval * 1000);
        // console.log(ChartsData?.apiData?.apiInterval);
      } else if (ChartsData?.currenEntry === 'apiData') {
        // console.log('不开启interval任务 只处理一次请求');
        let res = await this.getApiDataResByFilterAndResponseQuery();
        this.setEchartsOptions(res);
        this.$nextTick(() => {
          this.createEcharts();
        });
      }
    },
    // promise 返回api链接的请求数据
    getApiDataRes() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      return new Promise((resolve, reject) => {
        if (!ChartsData) resolve('Error ChartsData 不存在！');
        if (!ChartsData.apiData?.apiUrl) resolve('Error apiUrl 不存在！');
        // this.axios({
        //   method: 'get',
        //   url: ChartsData.apiData.apiUrl,
        // })
        let param = {
          method: 'get',
          url: ChartsData.apiData.apiUrl,
        };

        request(param)
          .then(res => {
            let data = this.$_.cloneDeep(res);
            resolve(data);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
    // promise 返回api链接的请求数据 使用ResponseQuery
    getApiDataResByResponseQuery() {
      return new Promise((resolve, reject) => {
        let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
        if (!ChartsData) reject('Error ChartsData 不存在！');
        this.getApiDataRes()
          .then(res => {
            // query数据
            let arryQuery = ChartsData.apiData.apiResponseQuery.split('.');
            if (arryQuery.length >= 1) {
              arryQuery.forEach(item => {
                res = res[item];
              });
            }
            // console.log('getApiDataResByResponseQuery');
            // console.log(res);
            let data = this.$_.cloneDeep(res);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // promise 返回api链接的请求数据 使用ResponseQuery和过滤器函数
    getApiDataResByFilterAndResponseQuery() {
      return new Promise((resolve, reject) => {
        let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
        if (!ChartsData) reject('Error ChartsData 不存在！');
        let filter = function (data, filter_text) {
          let dataSet = {};
          eval(filter_text);
          return dataSet;
        };
        this.getApiDataRes()
          .then(res => {
            // query数据
            let arryQuery = ChartsData.apiData.apiResponseQuery.split('.');
            if (arryQuery.length >= 1) {
              arryQuery.forEach(item => {
                res = res[item];
              });
            }
            // 判断是否使用过滤器
            if (ChartsData.apiData.isUseFilter) {
              res = filter(res, ChartsData.apiData.apiFilter);
            }
            // console.log('getApiDataResByFilterAndResponseQuery');
            // console.log(res);
            let data = this.$_.cloneDeep(res);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // 创建 Echarts 需要准备好echartsOptions数据 具有reload效果
    createEcharts() {
      this.destroyEcharts();
      let mychartDom = document.getElementById(this.Configuration.id);
      let mychart = Echarts.init(mychartDom, 'dark');
      mychart.setOption(this.echartsOptions);
    },
    // 自适应缩放 Echarts 尺寸大小
    resizeEcharts() {
      let mychartDom = document.getElementById(this.Configuration.id);
      let mychart = Echarts.getInstanceByDom(mychartDom);
      if (mychart) {
        mychart.resize();
      }
    },
    // 更新 echartsOptions 数据
    updateEcharts() {
      let mychartDom = document.getElementById(this.Configuration.id);
      let mychart = Echarts.getInstanceByDom(mychartDom);
      if (mychart) {
        mychart.setOption(this.echartsOptions);
      } else {
        this.createEcharts();
      }
    },
    // 销毁 Echarts 实例
    destroyEcharts() {
      let mychartDom = document.getElementById(this.Configuration.id);
      let mychart = Echarts.getInstanceByDom(mychartDom);
      if (mychart) {
        mychart.clear();
        mychart.dispose();
      }
    },
  },

  Configuration: {
    componentTitle: '速度仪表盘',
    componentName: 'Gauge3Charts',
    componentOverViewImg: './img/charts/GaugeCharts/Gauge3Charts.png',
    id: '',
    style: {
      width: 260,
      height: 260,
      left: 0,
      top: 0,
    },
    isScaling: false,
    isMoving: false,
    propertyData: {
      titleText: {
        value: '图表标题',
        lable: '图表标题',
        propertyComponentName: 'SingleInputor',
      },
      borderConfig: {
        propertyComponentName: 'ChartsBorderConfiger',
        value: {
          borderComponentName: 'Charts1Border',
        },
      },
      chartsColor: {
        propertyComponentName: 'ArrayColorSelector',
        value: {
          chartColor: ['#e6ebf8', '#100c2a', '#ffc300', '#00e473', '#009DFF'],
          chartBackgroundColor: 'rgba(34, 46, 57, 0.04)',
        },
      },
      ChartsData: {
        lable: '数据接入',
        propertyComponentName: 'ChartsDataConfigor',
        value: {
          currenEntry: 'staticData',
          apiData: {
            apiUrl:
              'https://restapi.amap.com/v3/weather/weatherInfo?city=%E6%9D%AD%E5%B7%9E&output=json&key=db5d2728c584e5884c385c2a509b29b9&extensions=all',
            // apiUrl:
            // 'http://192.168.0.173/gthmmc_v4.0/gthmmc/index.php?m=sdms&c=dataMange&a=completeStatisticsdata&data=%7B%22type%22:%22%E6%80%BB%E6%95%B0%22,%22date_start%22:%222021-03-01%22,%22date_end%22:%222021-03-31%22%7D&directory_code=pro_ownerstatistics&type=day',
            apiResponseQuery: 'data.forecasts',
            isUseFilter: true,
            apiFilter: `
          // 可以使用data访问api请求的响应结果        
let seriesList = []

let seriesListKey = 'city'
let seriesListChildrenKey = 'casts'

data.forEach((item) => {
  seriesList.push(item[seriesListKey])
})
dataSet.seriesList = seriesList
dataSet.source = []
data.forEach((item) => {
  item[seriesListChildrenKey].forEach(item2 => {
    dataSet.source.push({
      s: item[seriesListKey],
      x: item2.date,
      y: item2.daytemp
    })
  })
})
          `,
            isUseInterval: true,
            apiInterval: 10,
          },
          staticData: {
            seriesList: ['当前值', '最小值', '最大值'],
            source: [
              {
                min: '1',
                max: '100',
                i: '最小值',
                m: '最大值',
                s: '当前值',
                y: '20',
                x: '个数',
              },
            ],
          },
        },
      },
      posSize: {
        lable: '位置尺寸',
        propertyComponentName: 'ChartsPosSizeConfiger',
        value: {
          width: 260,
          height: 260,
          left: 50,
          top: 0,
        },
      },
      fontStyle: {
        lable: '图表文字样式',
        propertyComponentName: 'ChartsFontStyleConfiger',
        value: {
          titleSize: 16,
          titleColor: '#ccc',
          xAxisSize: 12,
          xAxisColor: '#c3dbff',
          yAxisSize: 12,
          yAxisColor: '#c3dbff',
        },
      },
      chartsGrid: {
        lable: '图表定位',
        propertyComponentName: 'ChartsGridConfiger',
        value: {
          top: '17%',
          bottom: '57%',
          left: '50%',
          right: '',
        },
      },
      showStatus: {
        value: 'norm',
      },
      chartsOpicity: {
        propertyComponentName: 'ChartsOpicityConfiger',
        value: 1,
      },
      chartsAnimation: {
        propertyComponentName: 'ChartsAnimationConfiger',
        value: {
          isUseAnimation: false,
          isUseStaticRefresh: false,
          staticRefreshIntervalTime: 5,
        },
      },
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.Gauge3Charts {
  color: white;
  width: 100%;
  height: 100%;

  .echarts {
    width: 100%;
    height: 100%;
  }
}
</style>
